import {Routes, RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {RealEstateCustomersService} from './features/real-estate/user-in/real-estate-clients/real-estate-customers.service';
import {SalesClientsService} from './features/sales/clients/sales-clients.service';

import {HomeComponent} from './layout/home/home.component';
import {AuthGuard} from './core/auth/auth.guard';
import {LoginRedirectGuard} from './core/guards/login-redirect.guard';
import {
  DevelopmentsGeneral
} from './features/inventories/developments/development-detail/tabs/general/general-tab.component';
import {
  DevelopmentDetailPageComponent
} from './features/inventories/developments/development-detail/development-detail.page';

// ───── Prospects ──────────────────────────────────────────────────────
const funnelsPage = () => import('./features/prospects/funnels/funnels.page')
  .then(m => m.FunnelsPage);
const funnelsFormPage = () => import('./features/prospects/funnels/form/funnels-form.page')
  .then(m => m.FunnelsFormPage);
const stagesPage = () => import('./features/prospects/tracking/tracking.stages.page')
  .then(m => m.ProcessStagesPageComponent);
const quotingPage = () => import('./features/quoting/quoting.page')
  .then(m => m.QuotingPage);
const realEstateAgenciesPage = () => import('./features/real-estate/real-state-agency/real-estate-agencies.page')
  .then(m => m.RealEstateAgenciesPage);
const realEstateAgencyDetailPage = () => import('./features/real-estate/real-state-agency/detail/real-estate-agency-detail.page')
  .then(m => m.RealEstateAgencyDetailPage);
const realEstateAgencyGeneral = () => import('./features/real-estate/real-state-agency/detail/tabs/general/real-estate-agency-general.component')
  .then(m => m.RealEstateAgencyGeneralComponent);
const realEstateAgencyAccessTab = () => import('./features/real-estate/real-state-agency/detail/tabs/access/real-estate-agency-access.component')
  .then(m => m.RealEstateAgencyAccessComponent);
const realEstateAgencyConsultantsTab = () => import('./features/real-estate/real-state-agency/detail/tabs/consultants/real-estate-agency-consultants.page')
  .then(m => m.RealEstateAgencyConsultantsPage);
const realEstateAgencyHistoryTab = () => import('./features/real-estate/real-state-agency/detail/tabs/history/real-estate-agency-history.page')
  .then(m => m.RealEstateAgencyHistoryPage);
const realEstateAgencyConsultantForm = () => import('./features/real-estate/real-state-agency/detail/tabs/consultants/real-estate-agency-consultant-form.component')
  .then(m => m.RealEstateAgencyConsultantFormComponent);
const realEstateQuotationsPage = () => import('./features/real-estate/user-in/real-estate-quotations/real-estate-quotations.page')
  .then(m => m.RealEstateQuotationsPage);
const realEstateQuotationFormPage = () => import('./features/real-estate/user-in/real-estate-quotations/real-estate-quotation-form.page')
  .then(m => m.RealEstateQuotationFormPage);
const realEstateQuotationDetailPage = () => import('./features/real-estate/user-in/real-estate-quotations/real-estate-quotation-detail.page')
  .then(m => m.RealEstateQuotationDetailPage);
const realEstateUnitBlocksPage = () => import('./features/real-estate/user-in/real-estate-unit-blocks/real-estate-unit-blocks.page')
  .then(m => m.RealEstateUnitBlocksPage);
const realEstateUnitBlockFormPage = () => import('./features/real-estate/user-in/real-estate-unit-blocks/real-estate-unit-block-form.page')
  .then(m => m.RealEstateUnitBlockFormPage);
const realEstateUnitBlockDetailPage = () => import('./features/real-estate/user-in/real-estate-unit-blocks/real-estate-unit-block-detail.page')
  .then(m => m.RealEstateUnitBlockDetailPage);
const realEstateSalesPage = () => import('./features/real-estate/user-in/real-estate-sales/real-estate-sales.page')
  .then(m => m.RealEstateSalesPage);
const realEstateSaleFormPage = () => import('./features/real-estate/user-in/real-estate-sales/real-estate-sale-form.page')
  .then(m => m.RealEstateSaleFormPage);
const appointmentsPage = () => import('./features/prospects/appointments/appointments.page')
  .then(m => m.AppointmentsPage);
const notificationCenterPage = () => import('./features/notificaciones/centro-notificaciones.page')
  .then(m => m.CentroNotificacionesPage);
const accountPage = () => import('./features/account/account.page')
  .then(m => m.AccountPage);
const firmaDigitalDashboardPage = () => import('./features/firma-digital/digital-signature-dashboard.page')
  .then(m => m.DigitalSignatureDashboardPage);
const digitalSignatureSettingsPage = () => import('./features/configuraciones/firma-digital/digital-signature-settings.page')
  .then(m => m.DigitalSignatureSettingsPage);

const prospectDetailPage = () => import('./features/prospects/prospect-detail/prospect-detail.page')
  .then(m => m.ProspectDetailPageComponent);

const prospectGeneralTab = () => import('./features/prospects/prospect-detail/tabs/general/general-tab.component')
  .then(m => m.GeneralTabComponent);
const prospectTrackingTab = () => import('./features/prospects/prospect-detail/tabs/tracking/tracking-tab.component')
  .then(m => m.TrackingTabComponent);
const prospectMessagesTab = () => import('./features/prospects/prospect-detail/tabs/messages/messages-tab.component')
  .then(m => m.MessagesTabComponent);
const prospectConversationsTab = () => import('./features/prospects/prospect-detail/tabs/conversations/conversations-tab.component')
  .then(m => m.ConversationsTabComponent);

// ───── Chat components ─────────────────────────────────────────────
const whatsappChatComponent = () => import('./features/chat/pages/whatsapp/whatsapp-chat/whatsapp-chat.component')
  .then(m => m.WhatsAppChatComponent);
const facebookChatComponent = () => import('./features/chat/pages/facebook/facebook-chat/facebook-chat.component')
  .then(m => m.FacebookChatComponent);
const instagramChatComponent = () => import('./features/chat/pages/instagram/instagram-chat/instagram-chat.component')
  .then(m => m.InstagramChatComponent);

// ───── Video Call components ──────────────────────────────────────────
const videoCallJoinComponent = () => import('./features/video-call/video-call-join/video-call-join.component')
  .then(m => m.VideoCallJoinComponent);
const prospectProjectsTab = () => import('./features/prospects/prospect-detail/tabs/projects/projects-tab.component')
  .then(m => m.ProjectsTabComponent);
const prospectPromotionsTab = () => import('./features/prospects/prospect-detail/tabs/promotions-tab.component')
  .then(m => m.PromotionsTabComponent);
const prospectPurchasesTab = () => import('./features/prospects/prospect-detail/tabs/purchases-tab.component')
  .then(m => m.PurchasesTabComponent);
const prospectDocumentsTab = () => import('./features/prospects/prospect-detail/tabs/documents-tab.component')
  .then(m => m.DocumentsTabComponent);
const prospectHistoryTab = () => import('./features/prospects/prospect-detail/tabs/history-tab.component')
  .then(m => m.HistoryTabComponent);
const prospectQuotationsTab = () => import('./features/prospects/prospect-detail/tabs/quotations/prospect-quotations-tab.component')
  .then(m => m.ProspectQuotationsTabComponent);
const prospectUnitBlocksTab = () => import('./features/prospects/prospect-detail/tabs/unit-blocks/prospect-unit-blocks-tab.component')
  .then(m => m.ProspectUnitBlocksTabComponent);
const prospectSalesTab = () => import('./features/prospects/prospect-detail/tabs/sales/prospect-sales-tab.component')
  .then(m => m.ProspectSalesTabComponent);
const salesClientsPage = () => import('./features/sales/clients/sales-clients.page')
  .then(m => m.SalesClientsPage);
const salesClientDetailPage = () => import('./features/sales/clients/detail/sales-client-detail.page')
  .then(m => m.SalesClientDetailPage);
const salesClientGeneralTab = () => import('./features/sales/clients/detail/tabs/general/sales-client-general.component')
  .then(m => m.SalesClientGeneralComponent);
const salesClientAdditionalInfoTab = () => import('./features/sales/clients/detail/tabs/additional-info')
  .then(m => m.SalesClientAdditionalInfoComponent);
const salesClientAddressesTab = () => import('./features/sales/clients/detail/tabs/addresses/sales-client-addresses.component')
  .then(m => m.SalesClientAddressesComponent);
const salesClientReferencesTab = () => import('./features/sales/clients/detail/tabs/references/sales-client-references.component')
  .then(m => m.SalesClientReferencesComponent);
const salesClientCoownersTab = () => import('./features/sales/clients/detail/tabs/coowners/sales-client-coowners.component')
  .then(m => m.SalesClientCoownersComponent);
const salesClientIdentityTab = () => import('./features/sales/clients/detail/tabs/identity/sales-client-identity.component')
  .then(m => m.SalesClientIdentityComponent);
const salesClientAccessTab = () => import('./features/sales/clients/detail/tabs/access/sales-client-access.component')
  .then(m => m.SalesClientAccessComponent);
const salesClientUnitsTab = () => import('./features/sales/clients/detail/tabs/units/sales-client-units.component')
  .then(m => m.SalesClientUnitsComponent);
const salesClientPlaceholderTab = () => import('./features/sales/clients/detail/placeholder-tab.component')
  .then(m => m.SalesClientPlaceholderTabComponent);

// ───── Conversations ─────────────────────────────────────────────────
const messagesPage = () => import('./features/conversations/messages/messages.page')
  .then(m => m.MessagesPage);
const messageShowPage = () => import('./features/conversations/messages/show/messages-show.page')
  .then(m => m.MessagesShowPage);

// ───── Inventories ───────────────────────────────────────────────────
const amenitiesPage = () => import('./features/inventories/catalogs/amenities/amenities.page')
  .then(m => m.AmenitiesPage);
const amenityFormPage = () => import('./features/inventories/catalogs/amenities/form/amenity-form.page')
  .then(m => m.AmenityFormPage);
const inventoryArticlesPage = () => import('./features/inventories/catalogs/inventory-articles/inventory-articles.page')
  .then(m => m.InventoryArticlesPage);
const inventoryArticleFormPage = () => import('./features/inventories/catalogs/inventory-articles/form/inventory-article-form.page')
  .then(m => m.InventoryArticleFormPage);

// ───── Prospects Catalog ─────────────────────────────────────────────────
const reasonLossPage = () => import('./features/prospects/catalog/reason-loss/reason-loss.page')
  .then(m => m.ReasonLossPage);
const reasonLossFormPage = () => import('./features/prospects/catalog/reason-loss/form/reason-loss-form.page')
  .then(m => m.ReasonLossFormPage);
const reasonReactivationPage = () => import('./features/prospects/catalog/reason-reactivation/reason-reactivation.page')
  .then(m => m.ReasonReactivationPage);
const reasonReactivationFormPage = () => import('./features/prospects/catalog/reason-reactivation/form/reason-reactivation-form.page')
  .then(m => m.ReasonReactivationFormPage);
const stageTypesPage = () => import('./features/prospects/catalog/stage-types/stage-types.page')
  .then(m => m.StageTypesPage);
const stageTypesFormPage = () => import('./features/prospects/catalog/stage-types/form/stage-types-form.page')
  .then(m => m.StageTypesFormPage);
const reasonAutomatedTrackingPage = () => import('./features/prospects/catalog/reason-automated-tracking/reason-automated-tracking.page')
  .then(m => m.ReasonAutomatedTrackingPage);
const reasonAutomatedTrackingFormPage = () => import('./features/prospects/catalog/reason-automated-tracking/form/reason-automated-tracking-form.page')
  .then(m => m.ReasonAutomatedTrackingFormPage);
const mediumPage = () => import('./features/prospects/catalog/medium/medium.page')
  .then(m => m.MediumPage);
const mediumFormPage = () => import('./features/prospects/catalog/medium/form/medium-form.page')
  .then(m => m.MediumFormPage);
const sourcePage = () => import('./features/prospects/catalog/source/source.page')
  .then(m => m.SourcePage);
const sourceFormPage = () => import('./features/prospects/catalog/source/form/source-form.page')
  .then(m => m.SourceFormPage);
const activityTypePage = () => import('./features/prospects/catalog/activity-type/activity-type.page')
  .then(m => m.ActivityTypePage);
const activityTypeFormPage = () => import('./features/prospects/catalog/activity-type/form/activity-type-form.page')
  .then(m => m.ActivityTypeFormPage);
const characteristicsPage = () => import('./features/inventories/catalogs/characteristics/characteristics.page')
  .then(m => m.CharacteristicsPage);
const characteristicForm = () => import('./features/inventories/catalogs/characteristics/form/characteristic-form.page')
  .then(m => m.CharacteristicFormPage);
const interestPointPage = () => import('./features/inventories/catalogs/interest-points/interest-point.page')
  .then(m => m.InterestPointPage);
const interestPointForm = () => import('./features/inventories/catalogs/interest-points/form/interest-point-form.page')
  .then(m => m.InterestPointFormPage);
const editInterestPoint = () => import('./features/inventories/catalogs/interest-points/edit-interest-point-page')
  .then(m => m.EditInterestPointPage);
const inventoryCancellationReasonsPage = () => import('./features/inventories/catalogs/inventory-cancellation-reasons/cancelation-reason.page')
  .then(m => m.CancelationReasonPage);
const inventoryCancellationReasonFormPage = () => import('./features/inventories/catalogs/inventory-cancellation-reasons/form/cancelation-reason-form.page')
  .then(m => m.CancelationReasonFormPage);
const inventoryUnitTypesPage = () => import('./features/inventories/catalogs/inventory-unit-types/unit-type.page')
  .then(m => m.UnitTypePage);
const inventoryUnitTypeFormPage = () => import('./features/inventories/catalogs/inventory-unit-types/form/unit-type-form.page')
  .then(m => m.UnitTypeFormPage);
const inventoryRegionsPage = () => import('./features/inventories/catalogs/inventory-regions/region.page')
  .then(m => m.RegionPage);
const inventoryRegionFormPage = () => import('./features/inventories/catalogs/inventory-regions/form/region-form.page')
  .then(m => m.RegionFormPage);

//  Tabs (edit interest-point)
const generalTab = () => import('./features/inventories/catalogs/interest-points/tabs/general-tab.component')
  .then(m => m.GeneralTabComponent);
const tagsTab = () => import('./features/inventories/catalogs/interest-points/tabs/tags-tab.component')
  .then(m => m.TagsTabComponent);
const docsTab = () => import('./features/inventories/catalogs/interest-points/tabs/documents-tab.component')
  .then(m => m.DocumentsTabComponent);
const historyTab = () => import('./features/inventories/catalogs/interest-points/tabs/history-tab.component')
  .then(m => m.HistoryTabComponent);
const sharedHistoryActionsTab = () => import('./shared/ui/history-actions-tab/history-actions-tab.component')
  .then(m => m.HistoryActionsTabComponent);

//  Otros inventarios
const developmentsPage = () => import('./features/inventories/developments/developments.page')
  .then(m => m.DevelopmentsPage);
const unitsPage = () => import('./features/inventories/units/units.page')
  .then(m => m.UnitsPage);
const paymentFormsPage = () => import('./features/inventories/payments/payment-forms/payment-forms.page')
  .then(m => m.PaymentFormsPage);
const paymentFormDetailPage = () => import('./features/inventories/payments/payment-forms/form/payment-form-detail.page')
  .then(m => m.PaymentFormDetailPage);
const paymentFormGeneralTab = () => import('./features/inventories/payments/payment-forms/form/tabs/general/payment-form-general.component')
  .then(m => m.PaymentFormGeneralComponent);
const paymentFormAccountsTab = () => import('./features/inventories/payments/payment-forms/form/tabs/accounts/payment-form-accounts.component')
  .then(m => m.PaymentFormAccountsComponent);
const paymentFormAppliesTab = () => import('./features/inventories/payments/payment-forms/form/tabs/applies/payment-form-applies.component')
  .then(m => m.PaymentFormAppliesComponent);
const paymentFormDiscountsTab = () => import('./features/inventories/payments/payment-forms/form/tabs/discounts/payment-form-discounts.component')
  .then(m => m.PaymentFormDiscountsComponent);
const paymentFormBonusesTab = () => import('./features/inventories/payments/payment-forms/form/tabs/bonuses/payment-form-bonuses.component')
  .then(m => m.PaymentFormBonusesComponent);
const paymentFormPromotionsTab = () => import('./features/inventories/payments/payment-forms/form/tabs/promotions/payment-form-promotions.component')
  .then(m => m.PaymentFormPromotionsComponent);
const discountsPage = () => import('./features/inventories/payments/discounts/discounts.page')
  .then(m => m.DiscountsPage);
const discountDetailPage = () => import('./features/inventories/payments/discounts/form/discount-detail.page')
  .then(m => m.DiscountDetailPage);
const discountGeneralTab = () => import('./features/inventories/payments/discounts/form/tabs/general/discount-general.component')
  .then(m => m.DiscountGeneralComponent);
const discountApplyTab = () => import('./features/inventories/payments/discounts/form/tabs/apply/discount-apply.component')
  .then(m => m.DiscountApplyComponent);
const bonusesPage = () => import('./features/inventories/payments/bonuses/bonuses.page')
  .then(m => m.BonusesPage);
const bonusDetailPage = () => import('./features/inventories/payments/bonuses/form/bonus-detail.page')
  .then(m => m.BonusDetailPage);
const bonusGeneralTab = () => import('./features/inventories/payments/bonuses/form/tabs/general/bonus-general.component')
  .then(m => m.BonusGeneralComponent);
const bonusApplyTab = () => import('./features/inventories/payments/bonuses/form/tabs/apply/bonus-apply.component')
  .then(m => m.BonusApplyComponent);
const promotionsPage = () => import('./features/inventories/payments/promotions/promotions.page')
  .then(m => m.PromotionsPage);
const promotionDetailPage = () => import('./features/inventories/payments/promotions/form/promotion-detail.page')
  .then(m => m.PromotionDetailPage);
const promotionGeneralTab = () => import('./features/inventories/payments/promotions/form/tabs/general/promotion-general.component')
  .then(m => m.PromotionGeneralComponent);
const promotionGalleryTab = () => import('./features/inventories/payments/promotions/form/tabs/gallery/promotion-gallery.component')
  .then(m => m.PromotionGalleryComponent);
const promotionApplyTab = () => import('./features/inventories/payments/promotions/form/tabs/apply/promotion-apply.component')
  .then(m => m.PromotionApplyComponent);
const paymentReferenceBanksPage = () => import('./features/inventories/payment-reference/banks/banks.page')
  .then(m => m.PaymentReferenceBanksPage);
const paymentReferenceBankAccountsPage = () => import('./features/inventories/payment-reference/bank-accounts/bank-accounts.page')
  .then(m => m.BankAccountsPage);
const paymentReferencesPage = () => import('./features/inventories/payment-reference/references/references.page')
  .then(m => m.PaymentReferencesPage);
const bankFormPage = () => import('./features/inventories/payment-reference/banks/bank-form.page')
  .then(m => m.BankFormPage);
const bankAccountFormPage = () => import('./features/inventories/payment-reference/bank-accounts/bank-account-form.page')
  .then(m => m.BankAccountFormPage);
const referenceFormPage = () => import('./features/inventories/payment-reference/references/reference-form.page')
  .then(m => m.ReferenceFormPage);
const conceptsPage = () => import('./features/inventories/payments/concepts/concepts.page')
  .then(m => m.ConceptsPage);
const conceptFormPage = () => import('./features/inventories/payments/concepts/form/concept-form.page')
  .then(m => m.ConceptFormPage);
const unitDetailPage = () => import('./features/inventories/units/unit-detail/unit-detail.page')
  .then(m => m.UnitDetailPageComponent);
const unitGeneralTab = () => import('./features/inventories/units/unit-detail/tabs/general/general-tab.component')
  .then(m => m.UnitGeneralTabComponent);
const unitCharacteristicsTab = () => import('./features/inventories/units/unit-detail/tabs/characteristics/characteristics-tab.component')
  .then(m => m.UnitCharacteristicsTabComponent);
const unitReferencesTab = () => import('./features/inventories/units/unit-detail/tabs/references/unit-references-tab.component')
  .then(m => m.UnitReferencesTabComponent);
const unitPaymentMethodsTab = () => import('./features/inventories/units/unit-detail/tabs/payment-methods/payment-methods-tab.component')
  .then(m => m.UnitPaymentMethodsTabComponent);
const unitPricesTab = () => import('./features/inventories/units/unit-detail/tabs/prices/unit-prices-tab.component')
  .then(m => m.UnitPricesTabComponent);
const unitDeedTab = () => import('./features/inventories/units/unit-detail/tabs/deed/unit-deed-tab.component')
  .then(m => m.UnitDeedTabComponent);
const unitStatusHistoryTab = () => import('./features/inventories/units/unit-detail/tabs/status/unit-status-history-tab.component')
  .then(m => m.UnitStatusHistoryTabComponent);
const unitBankAccountsTab = () => import('./features/inventories/units/unit-detail/tabs/bank-accounts/bank-accounts-tab.component')
  .then(m => m.UnitBankAccountsTabComponent);
const modelsPage = () => import('./features/inventories/models/models.page')
  .then(m => m.ModelsPage);
const modelDetailPage = () => import('./features/inventories/models/model-detail/model-detail.page')
  .then(m => m.ModelDetailPageComponent);
const modelGeneralTab = () => import('./features/inventories/models/model-detail/tabs/general/general-tab.component')
  .then(m => m.ModelGeneralTabComponent);
const modelMarketingTab = () => import('./features/inventories/models/model-detail/tabs/marketing/marketing-tab.component')
  .then(m => m.ModelMarketingTabComponent);
const modelPaymentMethodsTab = () => import('./features/inventories/models/model-detail/tabs/payment-methods/payment-methods-tab.component')
  .then(m => m.ModelPaymentMethodsTabComponent);
const modelUnitsTab = () => import('./features/inventories/models/model-detail/tabs/units/units-tab.component')
  .then(m => m.ModelUnitsTabComponent);
// Development tab
const developmentsGeneralPage = () => import('./features/inventories/developments/development-detail/development-detail.page')
  .then(m => m.DevelopmentDetailPageComponent);
const developmentsGeneral = () => import('./features/inventories/developments/development-detail/tabs/general/general-tab.component')
  .then(m => m.DevelopmentsGeneral);
const developmentsAdvisorPermissions = () => import('./features/inventories/developments/development-detail/tabs/advisor-permissions/advisor-permissions-tab.component')
  .then(m => m.AdvisorPermissionsTabComponent);
const developmentsMarketing = () => import('./features/inventories/developments/development-detail/tabs/marketing/marketing-tab.component')
  .then(m => m.DevelopmentMarketingTabComponent);
const developmentsMetaCarousel = () => import('./features/inventories/developments/development-detail/tabs/meta-carousel/meta-carousel-tab.component')
  .then(m => m.DevelopmentMetaCarouselTabComponent);
const developmentsTowers = () => import('./features/inventories/developments/development-detail/tabs/towers/towers-tab.component')
  .then(m => m.TowersTabComponent);
const developmentsUnits = () => import('./features/inventories/developments/development-detail/tabs/units/units-tab.component')
  .then(m => m.UnitsTabComponent);
const developmentsLevels = () => import('./features/inventories/developments/development-detail/tabs/levels/models-tab.component')
  .then(m => m.LevelsTabComponent);
const developmentsPaymentMethods = () => import('./features/inventories/developments/development-detail/tabs/payment-methods/payment-methods-tab.component')
  .then(m => m.PaymentMethodsTabComponent);
const developmentsPriceLists = () => import('./features/inventories/developments/development-detail/tabs/price-lists/price-lists-tab.component')
  .then(m => m.PriceListsTabComponent);
const developmentsAmenities = () => import('./features/inventories/developments/development-detail/tabs/amenities/amenities-tab.component')
  .then(m => m.AmenitiesTabComponent);
const developmentsInteresPoint = () => import('./features/inventories/developments/development-detail/tabs/interes-point/interes-point-tab-component')
  .then(m => m.InteresPointTabComponent);
const developmentsBankAccounts = () => import('./features/inventories/developments/development-detail/tabs/bank-accounts/bank-accounts-tab.component')
  .then(m => m.BankAccountsTabComponent);

const consultantsPage = () => import('./features/consultants/consultants.page')
  .then(m => m.ConsultantsPage);
const consultantsDetailPage = () => import('./features/consultants/consultants-detail/consultants-detail.page')
  .then(m => m.ConsultantDetailPageComponent);
const consultantsGeneralTab = () => import('./features/consultants/consultants-detail/tabs/general/general-data-form.component')
  .then(m => m.GeneralTabComponent);
const consultantsProjectsTab = () => import('./features/consultants/consultants-detail/tabs/projects/advisor-projects.page')
  .then(m => m.ConsultantProjectTabPage);
const consultantsTemporaryReplacementTab = () => import('./features/consultants/consultants-detail/tabs/temporary-replacement/temporary-replacement-tab.component')
  .then(m => m.ConsultantTemporaryReplacementTabComponent);
const consultantsRankingPage = () => import('./features/consultants/ranking/consultants-ranking.page')
  .then(m => m.ConsultantsRankingPage);

// ───── Customer Service Service Advisors ────────────────────────────────────────────
const serviceAdvisorsPage = () => import('./features/customer-service/service-advisors/service-advisors.page')
  .then(m => m.ServiceAdvisorsPage);
const serviceAdvisorsDetailPage = () => import('./features/customer-service/service-advisors/service-advisors-detail/service-advisors-detail.page')
  .then(m => m.ServiceAdvisorDetailPageComponent);
const serviceAdvisorsGeneralTab = () => import('./features/customer-service/service-advisors/service-advisors-detail/tabs/general/general-data-form.component')
  .then(m => m.ServiceAdvisorGeneralTabComponent);
const serviceAdvisorsProjectsTab = () => import('./features/customer-service/service-advisors/service-advisors-detail/tabs/projects/service-advisor-projects.page')
  .then(m => m.ServiceAdvisorProjectTabPage);
const constructionProgressPage = () => import('./features/customer-service/construction-progress/construction-progress.page')
  .then(m => m.ConstructionProgressPage);
const constructionProgressFormPage = () => import('./features/customer-service/construction-progress/form/construction-progress-form.page')
  .then(m => m.ConstructionProgressFormPage);

// ───── Customer Service Catalogs ──────────────────────────────────────────
const processPage = () => import('./features/customer-service/catalogs/process/process.page')
  .then(m => m.ProcessPage);
const processFormPage = () => import('./features/customer-service/catalogs/process/form/process-form.page')
  .then(m => m.ProcessFormPage);

const typePage = () => import('./features/customer-service/catalogs/type/type.page')
  .then(m => m.TypePage);
const typeFormPage = () => import('./features/customer-service/catalogs/type/form/type-form.page')
  .then(m => m.TypeFormPage);

const categoryPage = () => import('./features/customer-service/catalogs/category/category.page')
  .then(m => m.CategoryPage);
const categoryFormPage = () => import('./features/customer-service/catalogs/category/form/category-form.page')
  .then(m => m.CategoryFormPage);

const requestServiceActivityTypePage = () => import('./features/customer-service/catalogs/request-service-activity-type/request-service-activity-type.page')
  .then(m => m.RequestServiceActivityTypePage);
const requestServiceActivityTypeFormPage = () => import('./features/customer-service/catalogs/request-service-activity-type/form/request-service-activity-type-form.page')
  .then(m => m.RequestServiceActivityTypeFormPage);

// ───── Service Requests ───────────────────────────────────────────────────
const serviceRequestsStagesPage = () => import('./features/customer-service/service-requests/service-requests-stages.page')
  .then(m => m.ServiceRequestStagesPageComponent);

const serviceRequestDetailPage = () => import('./features/customer-service/service-requests/service-request-detail/service-request-detail.page')
  .then(m => m.ServiceRequestDetailPageComponent);

const serviceRequestGeneralTab = () => import('./features/customer-service/service-requests/service-request-detail/tabs/general-tab.component')
  .then(m => m.ServiceRequestGeneralTabComponent);

const serviceRequestTrackingTab = () => import('./features/customer-service/service-requests/service-request-detail/tabs/tracking-tab.component')
  .then(m => m.ServiceRequestTrackingTabComponent);

const serviceRequestWorksheetsTab = () => import('./features/customer-service/service-requests/service-request-detail/tabs/worksheets/service-request-worksheets-tab.component')
  .then(m => m.ServiceRequestWorksheetsTabComponent);

const serviceRequestLaborsTab = () => import('./features/customer-service/service-requests/service-request-detail/tabs/labors/service-request-labors-tab.component')
  .then(m => m.ServiceRequestLaborsTabComponent);

const serviceRequestMaterialsTab = () => import('./features/customer-service/service-requests/service-request-detail/tabs/materials/service-request-materials-tab.component')
  .then(m => m.ServiceRequestMaterialsTabComponent);

// ───── Campaigns Reactivation ────────────────────────────────────────────
const campaignsReactivationPage = () => import('./features/campaigns/campaigns-reactivation/campaigns-reactivation.page')
  .then(m => m.CampaignsReactivationPage);
const campaignsReactivationDetailPage = () => import('./features/campaigns/campaigns-reactivation/campaigns-reactivation-detail/campaigns-reactivation-detail.page')
  .then(m => m.CampaignsReactivationDetailPageComponent);
const campaignsReactivationGeneralTab = () => import('./features/campaigns/campaigns-reactivation/campaigns-reactivation-detail/tabs/general/general-data-form.component')
  .then(m => m.GeneralTabComponent);
const campaignsReactivationDevelopmentsTab = () => import('./features/campaigns/campaigns-reactivation/campaigns-reactivation-detail/tabs/developments/developments-tab.component')
  .then(m => m.DevelopmentsTabComponent);
const campaignsReactivationDeliveriesTab = () => import('./features/campaigns/campaigns-reactivation/campaigns-reactivation-detail/tabs/deliveries/deliveries-tab.component')
  .then(m => m.DeliveriesTabComponent);

// ───── Campaigns Types Catalog ────────────────────────────────────────────
const campaignsTypesPage = () => import('./features/campaigns/campaigns-types/campaigns-types.page')
  .then(m => m.CampaignsTypesPage);
const campaignsTypesFormPage = () => import('./features/campaigns/campaigns-types/form/campaigns-types-form.page')
  .then(m => m.CampaignsTypesFormPage);

// ───── Campaigns ────────────────────────────────────────────
const campaignsPage = () => import('./features/campaigns/campaigns/campaigns.page')
  .then(m => m.CampaignsPage);
const campaignsFormPage = () => import('./features/campaigns/campaigns/form/campaigns-form.page')
  .then(m => m.CampaignsFormPage);

// ───── Managers Control Panel ────────────────────────────────────────
const managersControlPanelPage = () => import('./features/managers/control-panel/managers-control-panel.page')
  .then(m => m.ManagersControlPanelPageComponent);
const salesAdvisorsControlPanelPage = () => import('./features/sales/control-panel/sales-advisors-control-panel.page')
  .then(m => m.SalesAdvisorsControlPanelPageComponent);
const inventoryTab = () => import('./features/managers/control-panel/tabs/inventory-tab.component')
  .then(m => m.InventoryTabComponent);
const referencesTab = () => import('./features/managers/control-panel/tabs/references-tab.component')
  .then(m => m.ReferencesTabComponent);
const logbookTab = () => import('./features/managers/control-panel/tabs/logbook-tab.component')
  .then(m => m.LogbookTabComponent);
const simulatorTab = () => import('./features/managers/control-panel/tabs/simulator-tab.component')
  .then(m => m.SimulatorTabComponent);
const priceListTab = () => import('./features/managers/control-panel/tabs/price-list-tab.component')
  .then(m => m.PriceListTabComponent);

// ───── Inventory Reports ─────────────────────────────────────────────
const disygaInventoryReportsPage = () => import('./features/inventories/reports/disyga-inventory/disyga-inventory-reports.page')
  .then(m => m.DisygaInventoryReportsPageComponent);
const trackingBoardReportsPage = () => import('./features/inventories/reports/tracking-board/tracking-board-reports.page')
  .then(m => m.TrackingBoardReportsPageComponent);

// DISYGA Inventory Reports Tabs
const wipReport = () => import('./features/inventories/reports/disyga-inventory/tabs/wip-report.component')
  .then(m => m.WipReportComponent);
const kpiReport = () => import('./features/inventories/reports/disyga-inventory/tabs/kpi-report.component')
  .then(m => m.KpiReportComponent);
const kpiEscriturasReport = () => import('./features/inventories/reports/disyga-inventory/tabs/kpi-escrituras-report.component')
  .then(m => m.KpiEscriturasReportComponent);
const inventarioReport = () => import('./features/inventories/reports/disyga-inventory/tabs/inventario-report.component')
  .then(m => m.InventarioReportComponent);
const operacionesTransitoriasReport = () => import('./features/inventories/reports/disyga-inventory/tabs/operaciones-transitorias-report.component')
  .then(m => m.OperacionesTransitoriasReportComponent);
const resumenBitacoraReport = () => import('./features/inventories/reports/disyga-inventory/tabs/resumen-bitacora-report.component')
  .then(m => m.ResumenBitacoraReportComponent);
const bitacoraReport = () => import('./features/inventories/reports/disyga-inventory/tabs/bitacora-report.component')
  .then(m => m.BitacoraReportComponent);

// Tracking Board Reports Tabs
const inventoryTrackingReport = () => import('./features/inventories/reports/tracking-board/tabs/inventory-tracking-report.component')
  .then(m => m.InventoryTrackingReportComponent);
const referencesTrackingReport = () => import('./features/inventories/reports/tracking-board/tabs/references-tracking-report.component')
  .then(m => m.ReferencesTrackingReportComponent);
const logbookTrackingReport = () => import('./features/inventories/reports/tracking-board/tabs/logbook-tracking-report.component')
  .then(m => m.LogbookTrackingReportComponent);
const simulatorTrackingReport = () => import('./features/inventories/reports/tracking-board/tabs/simulator-tracking-report.component')
  .then(m => m.SimulatorTrackingReportComponent);
const priceListTrackingReport = () => import('./features/inventories/reports/tracking-board/tabs/price-list-tracking-report.component')
  .then(m => m.PriceListTrackingReportComponent);
const salesRecordsPage = () => import('./features/crm/record/sales-records/sales-records.page')
  .then(m => m.SalesRecordsPage);
const dashboardRecordsPanelPage = () => import('./features/crm/control-panel/dashboard-records-panel/dashboard-records-panel.page')
  .then(m => m.DashboardRecordsPanelPage);
const salesRecordDetailPage = () => import('./features/crm/record/sales-records/detail/sales-record-detail.page')
  .then(m => m.SalesRecordDetailPage);
const cancellationRequestsPage = () => import('./features/crm/record/cancellation-requests/cancellation-requests.page')
  .then(m => m.CancellationRequestsPage);
const deedsPage = () => import('./features/crm/titling/deeds/deeds.page')
  .then(m => m.DeedsPage);
const deedDetailPage = () => import('./features/crm/titling/deeds/detail/deed-detail.page')
  .then(m => m.DeedDetailPage);
const notariesPage = () => import('./features/crm/titling/notaries/notaries.page')
  .then(m => m.NotariesPage);
const notaryDetailPage = () => import('./features/crm/titling/notaries/detail/notary-detail.page')
  .then(m => m.NotaryDetailPage);
const notaryGeneralTab = () => import('./features/crm/titling/notaries/detail/tabs/general/notary-general.component')
  .then(m => m.NotaryGeneralComponent);
const adminUsersPage = () => import('./features/panel/users-administration/users/users.page')
  .then(m => m.UsersPage);
const adminUserCreatePage = () => import('./features/panel/users-administration/users/users-create.page')
  .then(m => m.UsersCreatePage);
const adminUserDetailPage = () => import('./features/panel/users-administration/users/users-detail.page')
  .then(m => m.UsersDetailPage);
const adminRolesPage = () => import('./features/panel/users-administration/roles/roles.page')
  .then(m => m.RolesPage);
const legalRepresentativesPage = () => import('./features/configuraciones/usuarios-roles/legal-representatives/legal-representatives.page')
  .then(m => m.LegalRepresentativesPage);
const legalRepresentativeDetailPage = () => import('./features/configuraciones/usuarios-roles/legal-representatives/detail/legal-representative-detail.page')
  .then(m => m.LegalRepresentativeDetailPage);
const legalRepresentativeGeneralTab = () => import('./features/configuraciones/usuarios-roles/legal-representatives/detail/tabs/general/legal-representative-general.component')
  .then(m => m.LegalRepresentativeGeneralComponent);
const legalRepresentativeProjectsTab = () => import('./features/configuraciones/usuarios-roles/legal-representatives/detail/tabs/projects/legal-representative-projects.component')
  .then(m => m.LegalRepresentativeProjectsComponent);
const adminRoleDetailPage = () => import('./features/panel/users-administration/roles/roles-detail.page')
  .then(m => m.RolesDetailPage);
const leadSlaReassignmentReportPage = () => import('./features/reports/lead-sla-reassignment/lead-sla-reassignment-report.page')
  .then(m => m.LeadSlaReassignmentReportPage);

// ─────  Definición de rutas ───────────────────────────────────────────
export const routes: Routes = [

  /* Login ----------------------------------------------------------- */
  {
    path: 'login',
    canActivate: [LoginRedirectGuard],
    loadComponent: () => import('./features/auth/login.page')
      .then(m => m.LoginPage),
    data: {bg: '#F5F5F5'}
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/auth/password-reset/password-reset-request.page')
      .then(m => m.PasswordResetRequestPage),
    data: {bg: '#F5F5F5'}
  },
  {
    path: 'reset-password/code',
    loadComponent: () => import('./features/auth/password-reset/password-reset-verify.page')
      .then(m => m.PasswordResetVerifyPage),
    data: {bg: '#F5F5F5'}
  },
  {
    path: 'reset-password/new',
    loadComponent: () => import('./features/auth/password-reset/password-reset-new.page')
      .then(m => m.PasswordResetNewPage),
    data: {bg: '#F5F5F5'}
  },

  /* Video Call Join (Public) ---------------------------------------- */
  {
    path: 'video-call/join',
    loadComponent: videoCallJoinComponent,
    data: {bg: '#667eea'}
  },
  {
    path: 'crm/bell',
    redirectTo: 'notificaciones',
    pathMatch: 'full'
  },
  {
    path: 'notificaciones',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {path: '', loadComponent: notificationCenterPage}
    ]
  },
  {
    path: 'firma-digital',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {path: '', loadComponent: firmaDigitalDashboardPage},
      {path: ':documentUuid', loadComponent: firmaDigitalDashboardPage}
    ]
  },
  {
    path: 'legal-representative/control-panel',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {path: '', redirectTo: 'digital-signatures', pathMatch: 'full'},
      {path: 'digital-signatures', loadComponent: firmaDigitalDashboardPage},
      {path: 'digital-signatures/:documentUuid', loadComponent: firmaDigitalDashboardPage}
    ]
  },
  {
    path: 'crm/account',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {path: '', loadComponent: accountPage}
    ]
  },
  {
    path: 'crm/reports/lead-sla-reassignments',
    component: HomeComponent,
    canActivate: [AuthGuard],
    children: [
      {path: '', loadComponent: leadSlaReassignmentReportPage}
    ]
  },

  /* Shell principal: /:main/:sub ----------------------------------- */
  {
    path: ':main/:sub',
    component: HomeComponent,
    canActivate: [AuthGuard],

    children: [
      { path: 'account', loadComponent: accountPage },

      /* Cotizaciones inmobiliarias (real-estate/quotes) */
      { path: 'quotes', loadComponent: realEstateQuotationsPage },
      { path: 'quotes/new', loadComponent: realEstateQuotationFormPage },
      { path: 'quotes/:uuid', loadComponent: realEstateQuotationDetailPage },
      { path: 'blocks', loadComponent: realEstateUnitBlocksPage },
      { path: 'blocks/new', loadComponent: realEstateUnitBlockFormPage },
      { path: 'blocks/:uuid', loadComponent: realEstateUnitBlockDetailPage },

      {
        path: 'consultants',
        children: [
          {path: '', loadComponent: consultantsPage},
          {path: 'ranking', loadComponent: consultantsRankingPage},
          {path: 'new', loadComponent: consultantsGeneralTab},
          {
            path: 'consultants/:uuid',
            loadComponent: consultantsDetailPage,      // página padre
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: consultantsGeneralTab},
              {path: 'show', loadComponent: consultantsGeneralTab},
              {path: 'projects', loadComponent: consultantsProjectsTab},
              {path: 'temporary-replacement', loadComponent: consultantsTemporaryReplacementTab}
            ]
          }
        ]
      },
      {
        path: 'users',
        children: [
          {path: '', loadComponent: adminUsersPage},
          {path: 'new', loadComponent: adminUserCreatePage},
          {path: ':uuid', loadComponent: adminUserDetailPage},
          {path: ':uuid/show', loadComponent: adminUserDetailPage}
        ]
      },
      {
        path: 'roles',
        children: [
          {path: '', loadComponent: adminRolesPage},
          {path: 'new', loadComponent: adminRoleDetailPage},
          {path: ':uuid', loadComponent: adminRoleDetailPage},
          {path: ':uuid/show', loadComponent: adminRoleDetailPage}
        ]
      },
      {
        path: 'legal-representatives',
        children: [
          {path: '', loadComponent: legalRepresentativesPage},
          {
            path: 'nuevo',
            loadComponent: legalRepresentativeDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: legalRepresentativeGeneralTab}
            ]
          },
          {
            path: ':uuid',
            loadComponent: legalRepresentativeDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: legalRepresentativeGeneralTab},
              {path: 'projects', loadComponent: legalRepresentativeProjectsTab}
            ]
          }
        ]
      },
      {
        path: 'digital-signature-settings',
        loadComponent: digitalSignatureSettingsPage
      },
      {
        path: 'users-administration',
        children: [
          {path: '', redirectTo: 'roles', pathMatch: 'full'},
          {
            path: 'users',
            children: [
              {path: '', loadComponent: adminUsersPage},
              {path: 'new', loadComponent: adminUserCreatePage},
              {path: ':uuid', loadComponent: adminUserDetailPage},
              {path: ':uuid/show', loadComponent: adminUserDetailPage}
            ]
          },
          {
            path: 'roles',
            children: [
              {path: '', loadComponent: adminRolesPage},
              {path: 'new', loadComponent: adminRoleDetailPage},
              {path: ':uuid', loadComponent: adminRoleDetailPage},
              {path: ':uuid/show', loadComponent: adminRoleDetailPage}
            ]
          }
        ]
      },
      {
        path: 'real-estate',
        children: [
          { path: '', loadComponent: realEstateAgenciesPage },
          {
            path: 'new',
            loadComponent: realEstateAgencyDetailPage,
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', loadComponent: realEstateAgencyGeneral }
            ]
          },
          {
            path: ':uuid',
            loadComponent: realEstateAgencyDetailPage,
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', loadComponent: realEstateAgencyGeneral },
              { path: 'access', loadComponent: realEstateAgencyAccessTab },
              { path: 'consultants', loadComponent: realEstateAgencyConsultantsTab },
              { path: 'history', loadComponent: realEstateAgencyHistoryTab },
              { path: 'consultants/new', loadComponent: realEstateAgencyConsultantForm },
              { path: 'consultants/:consultantUuid', loadComponent: realEstateAgencyConsultantForm },
              { path: 'consultants/:consultantUuid/show', loadComponent: realEstateAgencyConsultantForm }
            ]
          },
          {
            path: ':uuid/show',
            loadComponent: realEstateAgencyDetailPage,
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', loadComponent: realEstateAgencyGeneral },
              { path: 'access', loadComponent: realEstateAgencyAccessTab },
              { path: 'consultants', loadComponent: realEstateAgencyConsultantsTab },
              { path: 'history', loadComponent: realEstateAgencyHistoryTab },
              { path: 'consultants/new', loadComponent: realEstateAgencyConsultantForm },
              { path: 'consultants/:consultantUuid', loadComponent: realEstateAgencyConsultantForm },
              { path: 'consultants/:consultantUuid/show', loadComponent: realEstateAgencyConsultantForm }
            ]
          }
        ]
      },
      {
        path: 'clients',
        children: [
          {
            path: '',
            loadComponent: salesClientsPage,
            providers: [{provide: SalesClientsService, useClass: RealEstateCustomersService}]
          },
          {
            path: 'new',
            loadComponent: salesClientDetailPage,
            providers: [{provide: SalesClientsService, useClass: RealEstateCustomersService}],
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: salesClientGeneralTab}
            ]
          },
          {
            path: ':uuid',
            loadComponent: salesClientDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: salesClientGeneralTab},
              {path: 'additional-info', loadComponent: salesClientAdditionalInfoTab},
              {path: 'addresses', loadComponent: salesClientAddressesTab},
              {path: 'references', loadComponent: salesClientReferencesTab},
              {path: 'fiscal', loadComponent: salesClientPlaceholderTab, data: {label: 'Datos fiscales'}},
              {path: 'coowners', loadComponent: salesClientCoownersTab},
              {path: 'identity-validation', loadComponent: salesClientIdentityTab},
                {path: 'access', loadComponent: salesClientAccessTab},
              {path: 'units', loadComponent: salesClientUnitsTab},
              {path: 'collection', loadComponent: salesClientPlaceholderTab, data: {label: 'Cobranza'}}
            ]
          }
        ]
      },
      {
        path: 'sales',
        children: [
          {path: '', loadComponent: realEstateSalesPage},
          {path: 'new', loadComponent: realEstateSaleFormPage},
          {path: ':uuid', loadComponent: realEstateSaleFormPage}
        ]
      },
      {path: 'sales-records', loadComponent: salesRecordsPage, data: {menu: 'records'}},
      {path: 'dashboard-records', loadComponent: dashboardRecordsPanelPage},
      {path: 'dashboard-records-panel', redirectTo: 'dashboard-records', pathMatch: 'full'},
      {path: 'customers', loadComponent: salesRecordsPage, data: {menu: 'customers'}},
      {path: 'managers', loadComponent: salesRecordsPage, data: {menu: 'managers'}},
      {path: 'sellers', loadComponent: salesRecordsPage, data: {menu: 'sellers'}},
      {path: 'real-estates', loadComponent: salesRecordsPage, data: {menu: 'real-estates'}},
      {path: 'advisors', loadComponent: salesRecordsPage, data: {menu: 'sellers'}},
      {path: 'cancellation-requests', loadComponent: cancellationRequestsPage},
      {path: 'deeds', loadComponent: deedsPage},
      {path: 'deeds/:saleUuid', loadComponent: deedDetailPage},
      {
        path: 'notaries',
        children: [
          {path: '', loadComponent: notariesPage},
          {
            path: 'new',
            loadComponent: notaryDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: notaryGeneralTab}
            ]
          },
          {
            path: ':uuid',
            loadComponent: notaryDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: notaryGeneralTab}
            ]
          }
        ]
      },
      {path: 'sales-records/:saleUuid', loadComponent: salesRecordDetailPage},
      {path: 'dashboard-records/:saleUuid', loadComponent: salesRecordDetailPage},
      {path: 'dashboard-records-panel/:saleUuid', loadComponent: salesRecordDetailPage},

       {
            path: 'customer-service-service-advisors',
            children: [
              {path: '', loadComponent: serviceAdvisorsPage},
              {path: 'new', loadComponent: serviceAdvisorsGeneralTab},
              {
                path: ':uuid',
                loadComponent: serviceAdvisorsDetailPage,
                children: [
                  {path: '', redirectTo: 'general', pathMatch: 'full'},
                  {path: 'general', loadComponent: serviceAdvisorsGeneralTab},
                  {path: 'show', loadComponent: serviceAdvisorsGeneralTab},
                  {path: 'projects', loadComponent: serviceAdvisorsProjectsTab}
                ]
              }
            ]
          },
          {
            path: 'customer-service-catalogs',
            children: [
              {
                path: 'service-request-process',
                children: [
                  {path: '', loadComponent: processPage},
                  {path: 'new', loadComponent: processFormPage},
                  {path: ':uuid/show', loadComponent: processFormPage},
                  {path: ':uuid/edit', loadComponent: processFormPage}
                ]
              },
              {
                path: 'service-request-type',
                children: [
                  {path: '', loadComponent: typePage},
                  {path: 'new', loadComponent: typeFormPage},
                  {path: ':uuid/show', loadComponent: typeFormPage},
                  {path: ':uuid/edit', loadComponent: typeFormPage}
                ]
              },
              {
                path: 'service-request-category',
                children: [
                  {path: '', loadComponent: categoryPage},
                  {path: 'new', loadComponent: categoryFormPage},
                  {path: ':uuid/show', loadComponent: categoryFormPage},
                  {path: ':uuid/edit', loadComponent: categoryFormPage}
                ]
              },
              {
                path: 'request-service-activity-type',
                children: [
                  {path: '', loadComponent: requestServiceActivityTypePage},
                  {path: 'new', loadComponent: requestServiceActivityTypeFormPage},
                  {path: ':uuid/show', loadComponent: requestServiceActivityTypeFormPage},
                  {path: ':uuid/edit', loadComponent: requestServiceActivityTypeFormPage}
                ]
              }
            ]
          },
          {
            path: 'customer-service-service-requests',
            loadComponent: serviceRequestsStagesPage
          },
          {
            path: 'customer-service-clients',
            children: [
              {path: '', loadComponent: salesClientsPage},
              {
                path: 'new',
                loadComponent: salesClientDetailPage,
                children: [
                  {path: '', redirectTo: 'general', pathMatch: 'full'},
                  {path: 'general', loadComponent: salesClientGeneralTab}
                ]
              },
              {
                path: ':uuid',
                loadComponent: salesClientDetailPage,
                children: [
                  {path: '', redirectTo: 'general', pathMatch: 'full'},
                  {path: 'general', loadComponent: salesClientGeneralTab},
                  {path: 'additional-info', loadComponent: salesClientAdditionalInfoTab},
                  {path: 'addresses', loadComponent: salesClientAddressesTab},
                  {path: 'references', loadComponent: salesClientReferencesTab},
                  {path: 'fiscal', loadComponent: salesClientPlaceholderTab, data: {label: 'Datos fiscales'}},
                  {path: 'coowners', loadComponent: salesClientCoownersTab},
                  {path: 'identity-validation', loadComponent: salesClientIdentityTab},
                {path: 'access', loadComponent: salesClientAccessTab},
                  {path: 'units', loadComponent: salesClientUnitsTab},
                  {path: 'collection', loadComponent: salesClientPlaceholderTab, data: {label: 'Cobranza'}}
                ]
              }
            ]
          },
          {
            path: 'customer-service-construction-progress',
            children: [
              { path: '', loadComponent: constructionProgressPage },
              { path: 'new', loadComponent: constructionProgressFormPage },
              { path: ':uuid/show', loadComponent: constructionProgressFormPage },
              { path: ':uuid/edit', loadComponent: constructionProgressFormPage }
            ]
          },
          {
            path: 'customer-service-service-request-form',
            loadComponent: () => import('./features/customer-service/service-requests/form/service-request-form.page')
              .then(m => m.ServiceRequestFormPageComponent)
          },
          {
            path: 'service-request/:uuid',
            loadComponent: serviceRequestDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: serviceRequestGeneralTab},
              {path: 'tracking', loadComponent: serviceRequestTrackingTab},
              {path: 'worksheets', loadComponent: serviceRequestWorksheetsTab},
              {path: 'labors', loadComponent: serviceRequestLaborsTab},
              {path: 'materials', loadComponent: serviceRequestMaterialsTab}
            ]
          },

      {
        path: 'campaigns-reactivation',
        children: [
          {path: '', loadComponent: campaignsReactivationPage},
          {path: 'new', loadComponent: campaignsReactivationGeneralTab},
          {
            path: ':uuid',
            loadComponent: campaignsReactivationDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: campaignsReactivationGeneralTab},
              {path: 'developments', loadComponent: campaignsReactivationDevelopmentsTab},
              {path: 'deliveries', loadComponent: campaignsReactivationDeliveriesTab}
            ]
          }
        ]
      },

      {
        path: 'campaigns-catalogs',
        children: [
          {
            path: 'campaigns-types',
            children: [
              {path: '', loadComponent: campaignsTypesPage},
              {path: ':model', loadComponent: campaignsTypesFormPage},
              {path: ':uuid/:model', loadComponent: campaignsTypesFormPage}
            ]
          }
        ]
      },

      {
        path: 'campaigns',
        children: [
          {path: '', loadComponent: campaignsPage},
          {path: 'new', loadComponent: campaignsFormPage},
          {path: ':uuid/show', loadComponent: campaignsFormPage},
          {path: ':uuid/edit', loadComponent: campaignsFormPage}
        ]
      },

      {
        path: 'process',
        children: [
          {path: '', loadComponent: funnelsPage},
          {path: ':model', loadComponent: funnelsFormPage},
          {path: ':uuid/:model', loadComponent: funnelsFormPage}
        ]
      },

      {
        path: 'tracking',
        children: [
          {path: '', loadComponent: stagesPage},
          {path: 'new', loadComponent: prospectGeneralTab},
          {
            path: 'prospect/:uuid',
            loadComponent: prospectDetailPage,      // página padre
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: prospectGeneralTab},
              {path: 'tracking', loadComponent: prospectTrackingTab},
              {path: 'messages', loadComponent: prospectMessagesTab},
              {
                path: 'conversations',
                loadComponent: prospectConversationsTab,
                children: [
                  {path: '', redirectTo: 'whatsapp', pathMatch: 'full'},
                  {path: 'whatsapp', loadComponent: whatsappChatComponent},
                  {path: 'facebook', loadComponent: facebookChatComponent},
                  {path: 'instagram', loadComponent: instagramChatComponent}
                ]
              },
              {path: 'projects', loadComponent: prospectProjectsTab},
              {path: 'promotions', loadComponent: prospectPromotionsTab},
              {path: 'purchases', loadComponent: prospectPurchasesTab},
              {path: 'documents', loadComponent: prospectDocumentsTab},
              {path: 'history', loadComponent: prospectHistoryTab},
              {path: 'quotations', loadComponent: prospectQuotationsTab},
              {path: 'sales', loadComponent: prospectSalesTab},
              {path: 'blocks', loadComponent: prospectUnitBlocksTab}
            ]
          },
        ]
      },

      // Alias para asesores de venta: abre el mismo tracking de prospectos
      {
        path: 'sales-advisors-prospects',
        children: [
          {path: '', loadComponent: stagesPage},
          {path: 'new', loadComponent: prospectGeneralTab},
          {
            path: 'prospect/:uuid',
            loadComponent: prospectDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: prospectGeneralTab},
              {path: 'tracking', loadComponent: prospectTrackingTab},
              {path: 'messages', loadComponent: prospectMessagesTab},
              {
                path: 'conversations',
                loadComponent: prospectConversationsTab,
                children: [
                  {path: '', redirectTo: 'whatsapp', pathMatch: 'full'},
                  {path: 'whatsapp', loadComponent: whatsappChatComponent},
                  {path: 'facebook', loadComponent: facebookChatComponent},
                  {path: 'instagram', loadComponent: instagramChatComponent}
                ]
              },
              {path: 'projects', loadComponent: prospectProjectsTab},
              {path: 'promotions', loadComponent: prospectPromotionsTab},
              {path: 'purchases', loadComponent: prospectPurchasesTab},
              {path: 'documents', loadComponent: prospectDocumentsTab},
              {path: 'history', loadComponent: prospectHistoryTab},
              {path: 'quotations', loadComponent: prospectQuotationsTab},
              {path: 'sales', loadComponent: prospectSalesTab},
              {path: 'blocks', loadComponent: prospectUnitBlocksTab}
            ]
          }
        ]
      },

      // Alias simple para asesores: Cotizador (no debe cargar el tracking)
      {
        path: 'sales-advisors-quoting',
        children: [
          { path: '', loadComponent: quotingPage }
        ]
      },

      // Real State Agency
      {
        path: 'real-state-agency',
        children: [
          { path: '', loadComponent: realEstateAgenciesPage },
          {
            path: 'new',
            loadComponent: realEstateAgencyDetailPage,
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', loadComponent: realEstateAgencyGeneral }
            ]
          },
          {
            path: ':uuid',
            loadComponent: realEstateAgencyDetailPage,
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', loadComponent: realEstateAgencyGeneral },
              { path: 'consultants', loadComponent: realEstateAgencyConsultantsTab },
              { path: 'history', loadComponent: realEstateAgencyHistoryTab },
              { path: 'consultants/new', loadComponent: realEstateAgencyConsultantForm },
              { path: 'consultants/:consultantUuid', loadComponent: realEstateAgencyConsultantForm },
              { path: 'consultants/:consultantUuid/show', loadComponent: realEstateAgencyConsultantForm }
            ]
          },
          {
            path: ':uuid/show',
            loadComponent: realEstateAgencyDetailPage,
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', loadComponent: realEstateAgencyGeneral },
              { path: 'consultants', loadComponent: realEstateAgencyConsultantsTab },
              { path: 'history', loadComponent: realEstateAgencyHistoryTab },
              { path: 'consultants/new', loadComponent: realEstateAgencyConsultantForm },
              { path: 'consultants/:consultantUuid', loadComponent: realEstateAgencyConsultantForm },
              { path: 'consultants/:consultantUuid/show', loadComponent: realEstateAgencyConsultantForm }
            ]
          }
        ]
      },

      // Managers alias for Real State Agency
      {
        path: 'managers-real-estate',
        children: [
          { path: '', loadComponent: realEstateAgenciesPage },
          {
            path: 'new',
            loadComponent: realEstateAgencyDetailPage,
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', loadComponent: realEstateAgencyGeneral }
            ]
          },
          {
            path: ':uuid',
            loadComponent: realEstateAgencyDetailPage,
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', loadComponent: realEstateAgencyGeneral },
              { path: 'history', loadComponent: realEstateAgencyHistoryTab }
            ]
          },
          {
            path: ':uuid/show',
            loadComponent: realEstateAgencyDetailPage,
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', loadComponent: realEstateAgencyGeneral },
              { path: 'history', loadComponent: realEstateAgencyHistoryTab }
            ]
          }
        ]
      },

      // Panel de control para gerentes
      {
        path: 'managers-control-panel',
        loadComponent: managersControlPanelPage,
        children: [
          {path: '', redirectTo: 'inventory', pathMatch: 'full'},
          {path: 'inventory', loadComponent: inventoryTab},
          {path: 'references', loadComponent: referencesTab},
          {path: 'logbook', loadComponent: logbookTab},
          {path: 'simulator', loadComponent: simulatorTab},
          {path: 'price-list', loadComponent: priceListTab}
        ]
      },
      {
        path: 'sales-advisors-control-panel',
        loadComponent: salesAdvisorsControlPanelPage,
        children: [
          {path: '', redirectTo: 'sales', pathMatch: 'full'},
          {path: 'sales', loadComponent: inventoryTrackingReport, data: {trackingSource: 'advisor-sales', trackingTitle: 'Ventas'}},
          {path: 'blocks', loadComponent: inventoryTrackingReport, data: {trackingSource: 'advisor-blocks', trackingTitle: 'Bloqueos'}}
        ]
      },

      // Alias para gerentes: abre el mismo tracking de prospectos
      {
        path: 'managers-prospects',
        children: [
          {path: '', loadComponent: stagesPage},
          {path: 'new', loadComponent: prospectGeneralTab},
          {
            path: 'prospect/:uuid',
            loadComponent: prospectDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: prospectGeneralTab},
              {path: 'tracking', loadComponent: prospectTrackingTab},
              {path: 'messages', loadComponent: prospectMessagesTab},
              {
                path: 'conversations',
                loadComponent: prospectConversationsTab,
                children: [
                  {path: '', redirectTo: 'whatsapp', pathMatch: 'full'},
                  {path: 'whatsapp', loadComponent: whatsappChatComponent},
                  {path: 'facebook', loadComponent: facebookChatComponent},
                  {path: 'instagram', loadComponent: instagramChatComponent}
                ]
              },
              {path: 'projects', loadComponent: prospectProjectsTab},
              {path: 'promotions', loadComponent: prospectPromotionsTab},
              {path: 'purchases', loadComponent: prospectPurchasesTab},
              {path: 'documents', loadComponent: prospectDocumentsTab},
              {path: 'history', loadComponent: prospectHistoryTab},
              {path: 'quotations', loadComponent: prospectQuotationsTab},
              {path: 'sales', loadComponent: prospectSalesTab},
              {path: 'blocks', loadComponent: prospectUnitBlocksTab}
            ]
          }
        ]
      },

      // Alias para gerentes: Consultores
      {
        path: 'managers-consultants',
        children: [
          {path: '', loadComponent: consultantsPage},
          {path: 'new', loadComponent: consultantsGeneralTab},
          {
            path: 'consultants/:uuid',
            loadComponent: consultantsDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: consultantsGeneralTab},
              {path: 'show', loadComponent: consultantsGeneralTab},
              {path: 'projects', loadComponent: consultantsProjectsTab},
              {path: 'temporary-replacement', loadComponent: consultantsTemporaryReplacementTab}
            ]
          }
        ]
      },

      // Alias para gerentes: Clientes (ventas)
      {
        path: 'managers-clients',
        children: [
          {path: '', loadComponent: salesClientsPage},
          {
            path: 'new',
            loadComponent: salesClientDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: salesClientGeneralTab}
            ]
          },
          {
            path: ':uuid',
            loadComponent: salesClientDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: salesClientGeneralTab},
              {path: 'additional-info', loadComponent: salesClientAdditionalInfoTab},
              {path: 'addresses', loadComponent: salesClientAddressesTab},
              {path: 'references', loadComponent: salesClientReferencesTab},
              {path: 'fiscal', loadComponent: salesClientPlaceholderTab, data: {label: 'Datos fiscales'}},
              {path: 'coowners', loadComponent: salesClientCoownersTab},
              {path: 'identity-validation', loadComponent: salesClientIdentityTab},
                {path: 'access', loadComponent: salesClientAccessTab},
              {path: 'units', loadComponent: salesClientUnitsTab},
              {path: 'collection', loadComponent: salesClientPlaceholderTab, data: {label: 'Cobranza'}}
            ]
          }
        ]
      },

      // Alias para gerentes: Desarrollos
      {
        path: 'managers-developments',
        children: [
          {path: '', loadComponent: developmentsPage},
          {path: 'new', loadComponent: developmentsGeneral},
          {
            path: ':uuid',
            loadComponent: developmentsGeneralPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: developmentsGeneral},
              {path: 'advisor-permissions', loadComponent: developmentsAdvisorPermissions},
              {path: 'marketing', loadComponent: developmentsMarketing},
              {path: 'meta-carousel', loadComponent: developmentsMetaCarousel},
              {path: 'towers', loadComponent: developmentsTowers},
              {path: 'levels', loadComponent: developmentsLevels},
              {path: 'units', loadComponent: developmentsUnits},
              {path: 'payment-methods', loadComponent: developmentsPaymentMethods},
              {path: 'amenities', loadComponent: developmentsAmenities},
              {path: 'points', loadComponent: developmentsInteresPoint},
              {path: 'bank-accounts', loadComponent: developmentsBankAccounts},
              {path: 'price-lists', loadComponent: developmentsPriceLists},
              {path: 'unities', loadComponent: tagsTab},
              {path: 'documents', loadComponent: docsTab},
              {path: 'history', loadComponent: historyTab}
            ]
          },
          {
            path: ':uuid/show',
            loadComponent: developmentsGeneralPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: developmentsGeneral},
              {path: 'advisor-permissions', loadComponent: developmentsAdvisorPermissions},
              {path: 'marketing', loadComponent: developmentsMarketing},
              {path: 'meta-carousel', loadComponent: developmentsMetaCarousel},
              {path: 'towers', loadComponent: developmentsTowers},
              {path: 'levels', loadComponent: developmentsLevels},
              {path: 'units', loadComponent: developmentsUnits},
              {path: 'payment-methods', loadComponent: developmentsPaymentMethods},
              {path: 'amenities', loadComponent: developmentsAmenities},
              {path: 'points', loadComponent: developmentsInteresPoint},
              {path: 'bank-accounts', loadComponent: developmentsBankAccounts},
              {path: 'price-lists', loadComponent: developmentsPriceLists},
              {path: 'unities', loadComponent: tagsTab},
              {path: 'documents', loadComponent: docsTab},
              {path: 'history', loadComponent: historyTab}
            ]
          }
        ]
      },

      {
        path: 'catalogs',
        children: [
          /* reason-loss */
          {
            path: 'reason-lost',
            children: [
              {path: '', loadComponent: reasonLossPage},
              {path: ':model', loadComponent: reasonLossFormPage},
              {path: ':uuid/:model', loadComponent: reasonLossFormPage}
            ]
          },
          {
            path: 'reason-reactivation',
            children: [
              {path: '', loadComponent: reasonReactivationPage},
              {path: ':model', loadComponent: reasonReactivationFormPage},
              {path: ':uuid/:model', loadComponent: reasonReactivationFormPage}
            ]
          },
          /* stage-types */
          {
            path: 'stage-types',
            children: [
              {path: '', loadComponent: stageTypesPage},
              {path: ':model', loadComponent: stageTypesFormPage},
              {path: ':uuid/:model', loadComponent: stageTypesFormPage}
            ]
          },
          /* reason-automated-tracking */
          {
            path: 'reason-automated-tracking',
            children: [
              {path: '', loadComponent: reasonAutomatedTrackingPage},
              {path: ':model', loadComponent: reasonAutomatedTrackingFormPage},
              {path: ':uuid/:model', loadComponent: reasonAutomatedTrackingFormPage}
            ]
          },
          /* medium */
          {
            path: 'medium',
            children: [
              {path: '', loadComponent: mediumPage},
              {path: ':model', loadComponent: mediumFormPage},
              {path: ':uuid/:model', loadComponent: mediumFormPage}
            ]
          },
          /* source */
          {
            path: 'source',
            children: [
              {path: '', loadComponent: sourcePage},
              {path: ':model', loadComponent: sourceFormPage},
              {path: ':uuid/:model', loadComponent: sourceFormPage}
            ]
          },
          /* activity-type */
          {
            path: 'activity-type',
            children: [
              {path: '', loadComponent: activityTypePage},
              {path: ':model', loadComponent: activityTypeFormPage},
              {path: ':uuid/:model', loadComponent: activityTypeFormPage}
            ]
          }
        ]
      },

      {
        path: 'appointments',
        children: [
          {path: '', loadComponent: appointmentsPage}
        ]
      },

      {
        path: 'sales-clients',
        children: [
          {path: '', loadComponent: salesClientsPage},
          {
            path: 'new',
            loadComponent: salesClientDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: salesClientGeneralTab}
            ]
          },
          {
            path: ':uuid',
            loadComponent: salesClientDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: salesClientGeneralTab},
              {path: 'additional-info', loadComponent: salesClientAdditionalInfoTab},
              {path: 'addresses', loadComponent: salesClientAddressesTab},
              {path: 'references', loadComponent: salesClientReferencesTab},
              {path: 'fiscal', loadComponent: salesClientPlaceholderTab, data: {label: 'Datos fiscales'}},
              {path: 'coowners', loadComponent: salesClientCoownersTab},
              {path: 'identity-validation', loadComponent: salesClientIdentityTab},
                {path: 'access', loadComponent: salesClientAccessTab},
              {path: 'units', loadComponent: salesClientUnitsTab},
              {path: 'collection', loadComponent: salesClientPlaceholderTab, data: {label: 'Cobranza'}}
            ]
          }
        ]
      },

      // Alias para asesores de venta: lista y edición de clientes
      {
        path: 'sales-advisors-clients',
        children: [
          {path: '', loadComponent: salesClientsPage},
          {
            path: 'new',
            loadComponent: salesClientDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: salesClientGeneralTab}
            ]
          },
          {
            path: ':uuid',
            loadComponent: salesClientDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: salesClientGeneralTab},
              {path: 'additional-info', loadComponent: salesClientAdditionalInfoTab},
              {path: 'addresses', loadComponent: salesClientAddressesTab},
              {path: 'references', loadComponent: salesClientReferencesTab},
              {path: 'fiscal', loadComponent: salesClientPlaceholderTab, data: {label: 'Datos fiscales'}},
              {path: 'coowners', loadComponent: salesClientCoownersTab},
              {path: 'identity-validation', loadComponent: salesClientIdentityTab},
                {path: 'access', loadComponent: salesClientAccessTab},
              {path: 'units', loadComponent: salesClientUnitsTab},
              {path: 'collection', loadComponent: salesClientPlaceholderTab, data: {label: 'Cobranza'}}
            ]
          }
        ]
      },

      /* ---------- Conversations (sub = conversations) ------------- */
      {
        path: 'messages',
        children: [
          {path: '', loadComponent: messagesPage},
          {path: ':uuid/:model', loadComponent: messageShowPage}
        ]
      },

      /* ---------- Inventory Reports (sub = control-panel) ---------- */
      {
        path: 'inventory',
        children: [
          {
            path: 'disyga-inventory',
            loadComponent: disygaInventoryReportsPage,
            children: [
              {path: 'wip', loadComponent: wipReport},
              {path: 'kpi', loadComponent: kpiReport},
              {path: 'kpi-escrituras', loadComponent: kpiEscriturasReport},
              {path: 'inventario', loadComponent: inventarioReport},
              {path: 'operaciones-transitorias', loadComponent: operacionesTransitoriasReport},
              {path: 'resumen-bitacora', loadComponent: resumenBitacoraReport},
              {path: 'bitacora', loadComponent: bitacoraReport}
            ]
          },
          {
            path: 'tracking-board',
            loadComponent: trackingBoardReportsPage,
            children: [
              {path: 'inventory', loadComponent: inventoryTrackingReport},
              {path: 'references', loadComponent: referencesTrackingReport},
              {path: 'logbook', loadComponent: logbookTrackingReport},
              {path: 'simulator', loadComponent: simulatorTrackingReport},
              {path: 'price-list', loadComponent: priceListTrackingReport}
            ]
          }
        ]
      },

      /* ---------- Inventories (sub = inventories) ----------------- */
      {
        path: 'catalogs',
        children: [

          /* amenities */
          {
            path: 'amenities',
            children: [
              {path: '', loadComponent: amenitiesPage},
              {path: ':model', loadComponent: amenityFormPage},
              {path: ':uuid/:model', loadComponent: amenityFormPage}
            ]
          },

          /* inventory-articles */
          {
            path: 'inventory-articles',
            children: [
              {path: '', loadComponent: inventoryArticlesPage},
              {path: ':model', loadComponent: inventoryArticleFormPage},
              {path: ':uuid/:model', loadComponent: inventoryArticleFormPage}
            ]
          },

          /* characteristics */
          {
            path: 'characteristics',
            children: [
              {path: '', loadComponent: characteristicsPage},
              {path: ':model', loadComponent: characteristicForm},
              {path: ':uuid/:model', loadComponent: characteristicForm}
            ]
          },

          /* interest-points */
          {
            path: 'interest-points',
            children: [
              {path: '', loadComponent: interestPointPage},
              {path: 'new', loadComponent: interestPointForm},
              {path: ':uuid/show', loadComponent: interestPointForm},
              {
                path: ':uuid/edit',
                loadComponent: editInterestPoint,
                children: [
                  {path: '', redirectTo: 'general', pathMatch: 'full'},
                  {path: 'general', loadComponent: generalTab},
                  {path: 'tags', loadComponent: tagsTab},
                  {path: 'documents', loadComponent: docsTab},
                  {path: 'history', loadComponent: historyTab}
                ]
              }
            ]
          },

          /* inventory cancellation reasons (alias) */
          {
            path: 'inventory-cancellation-reason',
            children: [
              {path: '', loadComponent: inventoryCancellationReasonsPage},
              {path: 'new', loadComponent: inventoryCancellationReasonFormPage},
              {path: ':uuid', loadComponent: inventoryCancellationReasonFormPage},
              {path: ':uuid/show', loadComponent: inventoryCancellationReasonFormPage}
            ]
          },

          /* inventory cancellation reasons */
          {
            path: 'inventory-cancellation-reasons',
            children: [
              {path: '', loadComponent: inventoryCancellationReasonsPage},
              {path: 'new', loadComponent: inventoryCancellationReasonFormPage},
              {path: ':uuid', loadComponent: inventoryCancellationReasonFormPage},
              {path: ':uuid/show', loadComponent: inventoryCancellationReasonFormPage}
            ]
          },

          /* inventory unit types */
          {
            path: 'inventory-unit-types',
            children: [
              {path: '', loadComponent: inventoryUnitTypesPage},
              {path: 'new', loadComponent: inventoryUnitTypeFormPage},
              {path: ':uuid', loadComponent: inventoryUnitTypeFormPage},
              {path: ':uuid/show', loadComponent: inventoryUnitTypeFormPage}
            ]
          },

          /* inventory regions */
          {
            path: 'inventory-regions',
            children: [
              {path: '', loadComponent: inventoryRegionsPage},
              {path: 'new', loadComponent: inventoryRegionFormPage},
              {path: ':uuid', loadComponent: inventoryRegionFormPage},
              {path: ':uuid/show', loadComponent: inventoryRegionFormPage}
            ]
          }
        ]
      },
      /* ---------- Otros inventarios de primer nivel --------------- */
      {
        path: 'developments',
        children: [
          {path: '', loadComponent: developmentsPage},
          {path: 'new', loadComponent: developmentsGeneral},
          {
            path: ':uuid',
            loadComponent: developmentsGeneralPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: developmentsGeneral},
              {path: 'advisor-permissions', loadComponent: developmentsAdvisorPermissions},
              {path: 'marketing', loadComponent: developmentsMarketing},
              {path: 'meta-carousel', loadComponent: developmentsMetaCarousel},
              {path: 'towers', loadComponent: developmentsTowers},
              {path: 'levels', loadComponent: developmentsLevels},
              {path: 'units', loadComponent: developmentsUnits},
              {path: 'payment-methods', loadComponent: developmentsPaymentMethods},
              {path: 'amenities', loadComponent: developmentsAmenities},
              {path: 'points', loadComponent: developmentsInteresPoint},
              {path: 'bank-accounts', loadComponent: developmentsBankAccounts},
              {path: 'price-lists', loadComponent: developmentsPriceLists},
              {path: 'unities', loadComponent: tagsTab},
              {path: 'documents', loadComponent: docsTab},
              {
                path: 'history',
                loadComponent: sharedHistoryActionsTab,
                data: {historyActions: {endpoint: '/developments/:uuid/history-actions', title: 'Historial'}}
              }
            ]
          }
          ,
          {
            path: ':uuid/show',
            loadComponent: developmentsGeneralPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: developmentsGeneral},
              {path: 'advisor-permissions', loadComponent: developmentsAdvisorPermissions},
              {path: 'marketing', loadComponent: developmentsMarketing},
              {path: 'meta-carousel', loadComponent: developmentsMetaCarousel},
              {path: 'towers', loadComponent: developmentsTowers},
              {path: 'levels', loadComponent: developmentsLevels},
              {path: 'units', loadComponent: developmentsUnits},
              {path: 'payment-methods', loadComponent: developmentsPaymentMethods},
              {path: 'amenities', loadComponent: developmentsAmenities},
              {path: 'points', loadComponent: developmentsInteresPoint},
              {path: 'bank-accounts', loadComponent: developmentsBankAccounts},
              {path: 'price-lists', loadComponent: developmentsPriceLists},
              {path: 'unities', loadComponent: tagsTab},
              {path: 'documents', loadComponent: docsTab},
              {
                path: 'history',
                loadComponent: sharedHistoryActionsTab,
                data: {historyActions: {endpoint: '/developments/:uuid/history-actions', title: 'Historial'}}
              }
            ]
          }
        ]
      },

      // Alias para asesores de venta: desarrollos
      {
        path: 'sales-advisors-developments',
        children: [
          {path: '', loadComponent: developmentsPage},
          {path: 'new', loadComponent: developmentsGeneral},
          {
            path: ':uuid',
            loadComponent: developmentsGeneralPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: developmentsGeneral},
              {path: 'advisor-permissions', loadComponent: developmentsAdvisorPermissions},
              {path: 'marketing', loadComponent: developmentsMarketing},
              {path: 'meta-carousel', loadComponent: developmentsMetaCarousel},
              {path: 'towers', loadComponent: developmentsTowers},
              {path: 'levels', loadComponent: developmentsLevels},
              {path: 'units', loadComponent: developmentsUnits},
              {path: 'payment-methods', loadComponent: developmentsPaymentMethods},
              {path: 'amenities', loadComponent: developmentsAmenities},
              {path: 'points', loadComponent: developmentsInteresPoint},
              {path: 'bank-accounts', loadComponent: developmentsBankAccounts},
              {path: 'price-lists', loadComponent: developmentsPriceLists},
              {path: 'unities', loadComponent: tagsTab},
              {path: 'documents', loadComponent: docsTab},
              {
                path: 'history',
                loadComponent: sharedHistoryActionsTab,
                data: {historyActions: {endpoint: '/developments/:uuid/history-actions', title: 'Historial'}}
              }
            ]
          }
          ,
          {
            path: ':uuid/show',
            loadComponent: developmentsGeneralPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: developmentsGeneral},
              {path: 'advisor-permissions', loadComponent: developmentsAdvisorPermissions},
              {path: 'marketing', loadComponent: developmentsMarketing},
              {path: 'meta-carousel', loadComponent: developmentsMetaCarousel},
              {path: 'towers', loadComponent: developmentsTowers},
              {path: 'levels', loadComponent: developmentsLevels},
              {path: 'units', loadComponent: developmentsUnits},
              {path: 'payment-methods', loadComponent: developmentsPaymentMethods},
              {path: 'amenities', loadComponent: developmentsAmenities},
              {path: 'points', loadComponent: developmentsInteresPoint},
              {path: 'bank-accounts', loadComponent: developmentsBankAccounts},
              {path: 'price-lists', loadComponent: developmentsPriceLists},
              {path: 'unities', loadComponent: tagsTab},
              {path: 'documents', loadComponent: docsTab},
              {
                path: 'history',
                loadComponent: sharedHistoryActionsTab,
                data: {historyActions: {endpoint: '/developments/:uuid/history-actions', title: 'Historial'}}
              }
            ]
          }
        ]
      },
      {
        path: 'units',
        children: [
          {path: '', loadComponent: unitsPage},
          {
            path: 'new',
            loadComponent: unitDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: unitGeneralTab}
            ]
          },
          {
            path: ':uuid',
            loadComponent: unitDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: unitGeneralTab},
              {path: 'characteristics', loadComponent: unitCharacteristicsTab},
              {path: 'payment-methods', loadComponent: unitPaymentMethodsTab},
              {path: 'prices', loadComponent: unitPricesTab},
              {path: 'references', loadComponent: unitReferencesTab},
              {path: 'bank-accounts', loadComponent: unitBankAccountsTab},
              {path: 'deed', loadComponent: unitDeedTab},
              {path: 'status-history', loadComponent: unitStatusHistoryTab},
              {
                path: 'history',
                loadComponent: sharedHistoryActionsTab,
                data: {historyActions: {endpoint: '/units/:uuid/history-actions', title: 'Historial'}}
              }
            ]
          }
        ]
      },
      {
        path: 'inventory-payment',
        children: [
          {
            path: 'inventory-payment-forms',
            children: [
              {path: '', loadComponent: paymentFormsPage},
              {path: 'new', loadComponent: paymentFormGeneralTab},
              {
                path: ':uuid',
                loadComponent: paymentFormDetailPage,
                children: [
                  {path: '', redirectTo: 'general', pathMatch: 'full'},
                  {path: 'general', loadComponent: paymentFormGeneralTab},
                  {path: 'accounts', loadComponent: paymentFormAccountsTab},
                  {path: 'discounts', loadComponent: paymentFormDiscountsTab},
                  {path: 'bonuses', loadComponent: paymentFormBonusesTab},
                  {path: 'promotions', loadComponent: paymentFormPromotionsTab},
                  {path: 'applies', loadComponent: paymentFormAppliesTab}
                ]
              }
            ]
          },
          {
            path: 'inventory-payment-discounts',
            children: [
              {path: '', loadComponent: discountsPage},
              {path: 'new', loadComponent: discountGeneralTab},
              {
                path: ':uuid',
                loadComponent: discountDetailPage,
                children: [
                  {path: '', redirectTo: 'general', pathMatch: 'full'},
                  {path: 'general', loadComponent: discountGeneralTab},
                  {path: 'apply', loadComponent: discountApplyTab}
                ]
              }
            ]
          },
          {
            path: 'inventory-payment-bonuses',
            children: [
              {path: '', loadComponent: bonusesPage},
              {path: 'new', loadComponent: bonusGeneralTab},
              {
                path: ':uuid',
                loadComponent: bonusDetailPage,
                children: [
                  {path: '', redirectTo: 'general', pathMatch: 'full'},
                  {path: 'general', loadComponent: bonusGeneralTab},
                  {path: 'apply', loadComponent: bonusApplyTab}
                ]
              }
            ]
          },
          {
            path: 'inventory-payment-promotions',
            children: [
              {path: '', loadComponent: promotionsPage},
              {path: 'new', loadComponent: promotionGeneralTab},
              {
                path: ':uuid',
                loadComponent: promotionDetailPage,
                children: [
                  {path: '', redirectTo: 'general', pathMatch: 'full'},
                  {path: 'general', loadComponent: promotionGeneralTab},
                  {path: 'gallery', loadComponent: promotionGalleryTab},
                  {path: 'apply', loadComponent: promotionApplyTab}
                ]
              }
            ]
          },
          {
            path: 'inventory-payment-concepts',
            children: [
              {path: '', loadComponent: conceptsPage},
              {path: 'new', loadComponent: conceptFormPage},
              {path: ':uuid', loadComponent: conceptFormPage}
            ]
          }
        ]
      },
      {
        path: 'inventory-payment-reference',
        children: [
          {
            path: 'inventory-payment-reference-banks',
            children: [
              {path: '', loadComponent: paymentReferenceBanksPage},
              {path: 'new', loadComponent: bankFormPage},
              {path: ':uuid', loadComponent: bankFormPage}
            ]
          },
          {
            path: 'inventory-payment-reference-bank-accounts',
            children: [
              {path: '', loadComponent: paymentReferenceBankAccountsPage},
              {path: 'new', loadComponent: bankAccountFormPage},
              {path: ':uuid', loadComponent: bankAccountFormPage}
            ]
          },
          {
            path: 'inventory-payment-reference-references',
            children: [
              {path: '', loadComponent: paymentReferencesPage},
              {path: 'new', loadComponent: referenceFormPage},
              {path: ':uuid', loadComponent: referenceFormPage}
            ]
          }
        ]
      },
      {
        path: 'models',
        children: [
          {path: '', loadComponent: modelsPage},
          {
            path: 'new',
            loadComponent: modelDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: modelGeneralTab}
            ]
          },
          {
            path: ':uuid',
            loadComponent: modelDetailPage,
            children: [
              {path: '', redirectTo: 'general', pathMatch: 'full'},
              {path: 'general', loadComponent: modelGeneralTab},
              {path: 'marketing', loadComponent: modelMarketingTab},
              {path: 'payment-methods', loadComponent: modelPaymentMethodsTab},
              {path: 'units', loadComponent: modelUnitsTab},
              {
                path: 'history',
                loadComponent: sharedHistoryActionsTab,
                data: {historyActions: {endpoint: '/models/:uuid/history-actions', title: 'Historial'}}
              }
            ]
          }
        ]
      },

      /* ---------- Fallback dentro del sub-menú --------------------- */
      {
        path: '**',
        loadComponent: () => import('./shared/not-found/not-found.component')
          .then(m => m.NotFoundComponent)
      }
    ]
  },

  /* Redirecciones globales ----------------------------------------- */
  {path: '', redirectTo: 'crm/prospects/tracking', pathMatch: 'full'}, // Placeholder inicial; Home redirige al menú por defecto
  {path: '**', redirectTo: 'login'}
];

export const MAIN_ROUTE = '/crm/prospects/tracking';

/* ------------------------------------------------------------------ */
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
